import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
// import localForage from 'localforage';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native

import rootReducer from '../reducers';

const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const middlewares = [thunkMiddleware];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(createLogger());
}

const enhancer = composeEnhancers(applyMiddleware(...middlewares));

const persistConfig = {
  key: 'flynn',
  storage,
  whitelist: ['currentUser'], // only navigation will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

function configureStore(preloadedState) {
  // with async await
  return createStore(persistedReducer, preloadedState, enhancer);
}

export default () => {
  const store = configureStore();
  const persistor = persistStore(store);
  return { store, persistor };
};



// WEBPACK FOOTER //
// ./src/store/index.js